module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/buying-chapter-hero-856ec8524d9989eceae25e6c2d287740.svg";